/**
 * @module geo/types/extensions
 */
import {Extension, ExtensionProperties, ExtensionType} from '.';


/**
 * Canvas extension that add a widget in side panel (PRO)
 *
 */
export interface PanelWidgetExtension extends Extension {
  type: ExtensionType.WIDGET_PANEL
  properties: PanelWidgetExtensionProperties
}
/**
 * Properties for Widget Panel extension
 */
export interface PanelWidgetExtensionProperties extends ExtensionProperties {
  /**
   * the standardized type of widget panel
   */
  type: WidgetPanelType;
  key: string;
  name?: string;
  nameKey?: string;
  priority: number;
  icon: string;
  /**
   * a template html or path or promise
   */
  template: string|Promise<any>;
  /**
   * a controller for the widget. Scope is injected with extensionConfig
   */
  controller: any;
  /**
   * optional callback called with the internal state of host widget component
   */
  configure?: (stateWidgetComponent: any) => void;
  /**
   * optional function that returns text to be displayed in a badge next to icon
   * (depending on widget type)
   */
  badge?: () => string
}

// @todo reference widget panel types
export enum WidgetPanelType {
  HEADER = 'header',
  WIDGETSIDE = 'widget.side',
  RIGHTPANEL = 'rightPanel',
  PRINT = 'print',
  WIDGETLARGE = 'widget.large',
  LEFTPANEL = 'leftpanel'
}


// widget.side pour les extensions widget s'inscrivant dans un panneau latéral
// gauche ou droite widget.large pour les extensions s'inscrivant dans un
// panneau large type footer map pour les extensions de la carte global pour les
// extensions globales global.pro pour les extensions globales spécifiques aux
// métiers "pro"
